import { ScrapData } from "@/pages/caster/models/ScrapData";
import { AgGridFooterActions } from "@/pages/eaf/data-entry/components/tables/components/AgGridFooterActions";
import { HelmetDexteel } from "@dexteel/mesf-core";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { useScrapTableData } from "./hooks/useScrapTableData";
import { UpsertDeleteScrapModal } from "./modals/UpsertDeleteScrapModal";

interface Props {
	refreshData: Function;
}

export const ScrapTable = ({ refreshData }: Props) => {
	const classes = useTableStyles();
	const { state, actions } = useCastersContext();
	const scrapReasons = state.scrapReasons || [];
	const scraps = state.scraps || [];
	const scrapTons = state.processData?.ScrapTons;

	const [showModal, setShowModal] = useState<boolean>(false);
	const [modalMode, setModalMode] = useState<"create" | "edit" | "delete">(
		"create",
	);
	const [scrapSelected, setScrapSelected] = useState<ScrapData | null>(null);

	const handleEditButtonClick = (scrap: ScrapData) => {
		setScrapSelected(scrap);
		setModalMode("edit");
		setShowModal(true);
		actions.setRefreshInPause(true);
	};

	const handleDeleteButtonClick = (scrap: ScrapData) => {
		setScrapSelected(scrap);
		setModalMode("delete");
		setShowModal(true);
		actions.setRefreshInPause(true);
	};

	const { columns } = useScrapTableData({
		scrapReasons,
		editCallback: handleEditButtonClick,
		deleteCallback: handleDeleteButtonClick,
	});

	return (
		<>
			{showModal && (
				<HelmetDexteel
					title={`${modalMode === "create" ? "New" : "Edit"} Scrap`}
				/>
			)}
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div
						className={`${classes.materialTable}`}
						style={{ height: "11.6rem", position: "relative" }}
					>
						<AgGridReact
							rowData={scraps}
							columnDefs={columns}
							domLayout="normal"
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							getRowId={(params) => params.data.ScrapId}
							suppressContextMenu
						/>
						<Box
							display="flex"
							justifyContent="center"
							width="100%"
							mt={3}
							style={{ position: "absolute", right: "4%" }}
						>
							<Typography
								style={{
									cursor: "default",
									userSelect: "none",
									fontSize: "0.8rem",
								}}
								key={`scrap-weight-${state.processData?.ProcessId}`}
							>
								Scrap Weight:{" "}
								<strong>
									{scrapTons !== null && scrapTons !== undefined
										? `${scrapTons} lbs`
										: ""}
								</strong>
							</Typography>
						</Box>
					</div>
				</Box>
				<Divider />
				<AgGridFooterActions
					hasMaxItems={false}
					showCreateModal={modalMode === "create"}
					setShowCreateModal={() => {
						setScrapSelected(null);
						setModalMode("create");
						setShowModal(true);
						actions.setRefreshInPause(true);
					}}
					table="scraps"
				/>
			</Paper>

			{showModal && (
				<UpsertDeleteScrapModal
					show={showModal}
					onHide={(shouldUpdate) => {
						setShowModal(false);
						if (shouldUpdate) {
							refreshData();
						}
						actions.setRefreshInPause(false);
					}}
					scrap={scrapSelected}
					mode={modalMode}
				/>
			)}
		</>
	);
};
